import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconSchool = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 22,
	viewBox: "0 0 26.0016 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M18.3986 9.67344L13.6504 5.25851C13.2803 4.91386 12.7228 4.91386 12.3504 5.25851L7.60212 9.67344C7.14796 10.0961 6.56164 10.3275 5.95609 10.3275H1.06367C0.477348 10.33 0.0015625 10.8281 0.0015625 11.4419V20.8881C0.0015625 21.5019 0.477348 22 1.06367 22H24.9395C25.5258 22 26.0016 21.5019 26.0016 20.8881V11.4419C26.0016 10.8281 25.5258 10.33 24.9395 10.33H20.0446C19.4367 10.33 18.8528 10.0961 18.3986 9.67595V9.67344Z",
				fill: "#93C5FD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.4871 0.274067C13.1587 0.142792 12.8016 0.384669 12.8016 0.73835V3.26132C12.8016 3.6151 13.1589 3.85698 13.4874 3.72551L16.6411 2.46315C17.0601 2.29542 17.06 1.7022 16.6409 1.53467L13.4871 0.274067Z",
				fill: "#93C5FD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.0016 10C13.5538 10 14.0016 9.55231 14.0016 9.00002C14.0016 8.44774 13.5538 8.00002 13.0016 8.00002C12.4493 8.00002 12.0016 8.44774 12.0016 9.00002C12.0016 9.55231 12.4493 10 13.0016 10Z",
				fill: "#395FE2"
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 19.9996V20.8605C0 21.4893 0.475786 21.9996 1.06211 21.9996H24.9379C25.5242 21.9996 26 21.4893 26 20.8605V19.9996H0Z",
			fill: "#395FE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 14.9996H12.5C11.9477 14.9996 11.5 15.4473 11.5 15.9996V19.9996C11.5 20.5519 11.9477 20.9996 12.5 20.9996H13.5C14.0523 20.9996 14.5 20.5519 14.5 19.9996V15.9996C14.5 15.4473 14.0523 14.9996 13.5 14.9996Z",
			fill: "#395FE2"
		})
	]
});
export default SvgIconSchool;
